import { Lease } from '@/types/residents/lease';

/**
 * Determine if WiFi should be available for a given lease.
 * Mirrors web logic: available from 30 days before start date until end date, or if subStatus === "Renewed".
 */
export const isWifiEligible = (lease?: Partial<Lease> & { subStatus?: string } | null): boolean => {
  if (!lease?.startDate || !lease?.endDate) return false;
  const start = new Date(new Date(lease.startDate).setHours(0, 0, 0));
  start.setDate(start.getDate() - 30);
  const end = new Date(new Date(lease.endDate).setHours(0, 0, 0));
  const today = new Date(new Date().setHours(0, 0, 0));
  const renewal = lease.subStatus === 'Renewed';
  return (start <= today && end >= today) || renewal;
};

export default isWifiEligible;


